"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tooltipPropDefs = void 0;
const tooltipPropDefs = {
    content: { type: 'ReactNode', default: undefined, required: true },
};
exports.tooltipPropDefs = tooltipPropDefs;
//# sourceMappingURL=tooltip.props.js.map